module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "imageInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/png,image/svg,image/gif",
      "id": "upload-image-input"
    },
    on: {
      "change": _vm.uploadImage
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5190cdce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUpload.vue
// module id = 678
// module chunks = 2